module.exports = __webpack_public_path__ + "img/footer-logo3.e5202805.png";